import { useState } from "react";
import styles from "../style/contact.module.css";
import heroBg from "../images/hero-bg.png";
import officeAdd from "../images/office_add.svg";
import emailICon from "../images/email_add.svg";
import phoneIcon from "../images/phone_number.svg";
import contactIllustration from "../images/contact-illustration.png";
import Features from "../components/features/Features";
import { ErrorMessage, Field, Form, Formik } from "formik";
import * as Yup from "yup";
import { toast } from "react-toastify";
import { PostApi } from "../api/api-service";
import { API_Path } from "../Const";
import PhoneInput from "react-phone-input-2";
// import bannerBg from "./banner-bg.png";

const addressData = [
    { icon: emailICon, label: "Email Address", value: "info@leadtracks.ai" },
    { icon: officeAdd, label: "Office Address", value: "5th floor office no 510, Opal Tower, Business Bay Dubai, UAE" },
    { icon: phoneIcon, label: "Phone Number", value: "+971 50 361 5200" },
];

/* ── SVG Icons ───────────────────────── */
const Icon = {
    Mail: () => (
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <rect x="2" y="4" width="20" height="16" rx="2" />
            <path d="m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7" />
        </svg>
    ),
    Phone: () => (
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07A19.5 19.5 0 0 1 4.15 11.93a19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 3.1 1.11h3a2 2 0 0 1 2 1.72c.127.96.361 1.903.7 2.81a2 2 0 0 1-.45 2.11L7.09 8.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0 1 21 16.92z" />
        </svg>
    ),
    MapPin: () => (
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <path d="M20 10c0 6-8 12-8 12S4 16 4 10a8 8 0 1 1 16 0z" />
            <circle cx="12" cy="10" r="3" />
        </svg>
    ),
    User: () => (
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <circle cx="12" cy="8" r="4" />
            <path d="M4 20c0-4 3.6-7 8-7s8 3 8 7" />
        </svg>
    ),
    Subject: () => (
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <path d="M3 3h18v4H3zM3 11h18M3 15h14M3 19h10" />
        </svg>
    ),
    Send: () => (
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
            <path d="m22 2-11 11" />
            <path d="M22 2 15 22 11 13l-9-4 20-7z" />
        </svg>
    ),
    Facebook: () => (
        <svg width="14" height="14" viewBox="0 0 24 24" fill="currentColor">
            <path d="M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3z" />
        </svg>
    ),
    Linkedin: () => (
        <svg width="14" height="14" viewBox="0 0 24 24" fill="currentColor">
            <path d="M16 8a6 6 0 0 1 6 6v7h-4v-7a2 2 0 0 0-2-2 2 2 0 0 0-2 2v7h-4v-7a6 6 0 0 1 6-6zM2 9h4v12H2z" />
            <circle cx="4" cy="4" r="2" />
        </svg>
    ),
    Instagram: () => (
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <rect x="2" y="2" width="20" height="20" rx="5" />
            <circle cx="12" cy="12" r="4" />
            <circle cx="17.5" cy="6.5" r="0.5" fill="currentColor" />
        </svg>
    ),
    Heart: () => (
        <svg width="14" height="14" viewBox="0 0 24 24" fill="currentColor">
            <path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z" />
        </svg>
    ),
    Home: () => (
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <path d="m3 9 9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z" />
            <polyline points="9 22 9 12 15 12 15 22" />
        </svg>
    ),
    Shield: () => (
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
        </svg>
    ),
    Star: () => (
        <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor" stroke="none">
            <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z" />
        </svg>
    ),
    Check: () => (
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
            <path d="M20 6 9 17l-5-5" />
        </svg>
    ),
    ArrowRight: () => (
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
            <path d="M5 12h14M12 5l7 7-7 7" />
        </svg>
    ),
    Agents: () => (
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" />
            <circle cx="9" cy="7" r="4" />
            <path d="M23 21v-2a4 4 0 0 0-3-3.87M16 3.13a4 4 0 0 1 0 7.75" />
        </svg>
    ),
    Building: () => (
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <rect x="4" y="2" width="16" height="20" rx="2" />
            <path d="M9 22v-4h6v4M8 6h.01M16 6h.01M8 10h.01M16 10h.01M8 14h.01M16 14h.01" />
        </svg>
    ),
    MapMark: () => (
        <svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
            <path d="M20 10c0 6-8 12-8 12S4 16 4 10a8 8 0 1 1 16 0z" />
            <circle cx="12" cy="10" r="3" />
        </svg>
    ),
};

/* ── Component ────────────────────────── */
export default function ContactPage() {
    const [isLoader, setIsLoader] = useState(false);
    const setSubmitData = async (formdata, resetForm) => {
        try {
            setIsLoader(true);
            let res = await PostApi(API_Path.contactUS, formdata);
            if (res.data.success) {
                toast.success(res.data.message);
                resetForm();
            } else toast.error(res.data.message);
            setIsLoader(false);
        } catch (error) {
            setIsLoader(false);
        }
    };

    return (
        <div className={styles.page}>
            {/* ── Hero ── */}
            <section className={styles.hero}>
                <img src={heroBg} alt="Dubai skyline" className={styles.heroBg} />
                <div className={styles.heroOverlay} />
                <div className="container">
                    <div className={styles.heroContent}>
                        <div className={styles.heroTag}>Get in Touch</div>
                        <h1 className={styles.heroTitle}>Contact Us</h1>
                        <p className={styles.heroSubtitle}>We're here to help! Reach out to us for any inquiries or assistance.</p>
                    </div>
                </div>
            </section>

            {/* ── Contact Info + Map ── */}
            <section className={styles.contactInfoSection}>
                <div className="container">
                    <div className={styles.info_row}>
                        <div className={styles.contactCards}>
                            {addressData.map(({ icon: Ico, label, value }, i) => (
                                <div key={i} className={styles.contactCard}>
                                    <div className={styles.cardIconWrap}>
                                        <img src={Ico} alt={label} />
                                    </div>
                                    <div className={styles.cardBody}>
                                        <div className={styles.cardLabel}>{label}</div>
                                        <div className={styles.cardValue}>{value}</div>
                                    </div>
                                </div>
                            ))}
                        </div>

                        <div className={styles.mapContainer}>
                            <iframe title="Opal Tower, Business Bay Dubai" src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3610.178508985432!2d55.265!3d25.185!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3e5f69279c0bbe33%3A0x5b5e1fd2ae3c8e3!2sOpal+Tower+-+Business+Bay!5e0!3m2!1sen!2sae!4v1600000000000!5m2!1sen!2sae" allowFullScreen="" loading="lazy" referrerPolicy="no-referrer-when-downgrade" />
                        </div>
                    </div>
                </div>
            </section>

            {/* ── Form Section ── */}
            <section className={styles.formSection}>
                {/* Left */}
                <div className="container">
                    <div className={styles.from_row}>
                        <div className={styles.formLeft}>
                            <div className={styles.sectionTag}>Send Us a Message</div>
                            <h2 className={styles.formTitle}>Get in touch</h2>
                            <p className={styles.formDesc}>Have a question or need help? Fill out the form and our team will get back to you shortly.</p>

                            <div className={styles.formIllustration}>
                                <img src={contactIllustration} alt="Contact" />
                            </div>
                        </div>

                        {/* Right — Form */}
                        <div className={styles.formRight}>
                            <Formik
                                initialValues={{ name: "", emailId: "", phoneNumber: "", subject: "", message: "" }}
                                validationSchema={Yup.object().shape({
                                    name: Yup.string().required("Full name is required."),
                                    emailId: Yup.string().matches(/^[^\s@]+@[^\s@]+\.[^\s@]+$/, "Enter a valid email address.").email("Your email address must be in the format of name@domain.com.").required("Email is required."),
                                    phoneNumber: Yup.string().min(9, "Phone number is required.").required("Phone number is required."),
                                    subject: Yup.string().required("Subject is required."),
                                    message: Yup.string().required("Note is required."),
                                })}
                                onSubmit={(values, { resetForm }) => {
                                    setSubmitData(values, resetForm);
                                }}
                            >
                                {(runform) => (
                                    <Form onSubmit={runform.handleSubmit}>
                                        <div className={styles.formGrid}>
                                            <div className={styles.formGroup}>
                                                <label className={styles.formLabel}>
                                                    Full Name <span>*</span>
                                                </label>
                                                <div className={styles.inputWrap}>
                                                    <Icon.User />
                                                    <Field type="text" name="name" placeholder="Full name" className={`${styles.formInput} ${runform.errors.name && runform.touched.name ? "error-bdr" : ""}`} />
                                                    {/* className={`form-control ${runform.errors.fullName && runform.touched.fullName ? "error-bdr" : ""}`} */}
                                                </div>
                                                <ErrorMessage name="name" component="span" className="error-message" />
                                            </div>
                                            <div className={styles.formGroup}>
                                                <label className={styles.formLabel}>
                                                    Email Address <span>*</span>
                                                </label>
                                                <div className={styles.inputWrap}>
                                                    <Icon.Mail />
                                                    <Field type="email" name="emailId" placeholder="Email address" className={`${styles.formInput} ${runform.errors.emailId && runform.touched.emailId ? "error-bdr" : ""}`} />
                                                </div>
                                                <ErrorMessage name="emailId" component="span" className="error-message" />
                                            </div>
                                            <div className={styles.formGroup}>
                                                <label className={styles.formLabel}>
                                                    Subject <span>*</span>
                                                </label>
                                                <div className={styles.inputWrap}>
                                                    <Icon.Subject />
                                                    <Field type="text" name="subject" placeholder="Subject" className={`${styles.formInput} ${runform.errors.subject && runform.touched.subject ? "error-bdr" : ""}`} />
                                                </div>
                                                <ErrorMessage name="subject" component="span" className="error-message" />
                                            </div>
                                            <div className={`${styles.formGroup} form_phone`}>
                                                <label className={styles.formLabel}>
                                                    Phone Number <span>*</span>
                                                </label>
                                                <Field name="phoneNumber">
                                                    {({ field, form }) => {
                                                        return <PhoneInput {...field} country="ae" inputClass={form.errors?.phoneNumber && form.touched?.phoneNumber ? "input-error" : ""} value={runform.values.phoneNumber} onChange={(phone) => form.setFieldValue("phoneNumber", phone)} enableSearch={true} />;
                                                    }}
                                                </Field>
                                                <ErrorMessage name="phoneNumber" component="span" className="error-message" />
                                            </div>
                                            <div className={`${styles.formGroup} ${styles.fullWidth}`}>
                                                <label className={styles.formLabel}>
                                                    Note <span>*</span>
                                                </label>
                                                <Field as="textarea" name="message" rows="4" placeholder="Note" className={`${styles.textarea} ${runform.errors.subject && runform.touched.subject ? "error-bdr" : ""}`} />
                                                <ErrorMessage name="message" component="span" className="error-message" />
                                            </div>
                                        </div>
                                        <div className={styles.formButton}>
                                            <button type="submit" className="button" disabled={isLoader}>
                                                Send Message
                                            {isLoader && <span className="spinner-border spinner-border-sm ms-2" role="status" aria-hidden="true"></span>}
                                            </button>
                                        </div>
                                    </Form>
                                )}
                            </Formik>
                        </div>
                    </div>
                </div>
            </section>

            <Features />
        </div>
    );
}
